var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"zoom"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"errorClass"},[_c('w-icon',{staticClass:"icon",attrs:{"icon":"alert-circle"}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }